'use client'

import { cx } from '@/lib/utils'

interface GeneralPopupHeadingProps {
  eyebrow: string | null
  title: string | null
  className?: string
}

export const GeneralPopupHeading = ({ eyebrow, title, className }: GeneralPopupHeadingProps) => {
  if (!eyebrow && !title) {
    return null
  }

  return (
    <div className={cx('space-y-2', className)}>
      {eyebrow ? <p className="text-lapis text-xs leading-none font-bold tracking-wide uppercase">{eyebrow}</p> : null}
      {title ? <h2 className="text-navy text-3xl font-bold tracking-tight">{title}</h2> : null}
    </div>
  )
}
